import { defineComponent as D, ref as f, watch as j, onMounted as x, getCurrentInstance as I, unref as A, onBeforeUnmount as E, setBlockTracking as b, createElementVNode as h, mergeProps as O, renderSlot as R, h as S, render as T } from "vue";
const g = [
  "childRow",
  "column-sizing",
  "column-visibility",
  "destroy",
  "draw",
  "error",
  "init",
  "length",
  "order",
  "page",
  "preDraw",
  "preInit",
  "preXhr",
  "processing",
  "requestChild",
  "search",
  "stateLoadParams",
  "stateLoaded",
  "stateSaveParams",
  "xhr",
  "autoFill",
  "preAutoFill",
  "buttons-action",
  "buttons-processing",
  "column-reorder",
  "key",
  "key-blur",
  "key-focus",
  "key-refocus",
  "key-return-submit",
  "responsive-display",
  "responsive-resize",
  "rowgroup-datasrc",
  "pre-row-reorder",
  "row-reorder",
  "row-reordered",
  "dtsb-inserted",
  "deselect",
  "select",
  "select-blur",
  "selectItems",
  "selectStyle",
  "user-select",
  "stateRestore-change"
];
let p;
const _ = {
  name: "Datatables.netVue",
  inheritAttrs: !1,
  use(i) {
    p = i;
  }
}, C = /* @__PURE__ */ D({
  ..._,
  props: {
    ajax: null,
    columns: null,
    data: null,
    options: null
  },
  emits: g,
  setup(i, { expose: d }) {
    const s = i, m = f(null), o = {}, c = f(), w = f([]);
    j(
      () => s.data,
      (r) => {
        let e = c.value;
        if (e) {
          for (var n = Object.keys(o), a = 0; a < n.length; a++)
            delete o[n[a]];
          e.clear(), e.rows.add(r).draw(!1);
        }
      },
      {
        deep: !0
      }
    ), x(() => {
      var n;
      const r = I();
      let e = s.options || {};
      if (s.data && (e.data = s.data, k(e.data)), s.columns && (e.columns = s.columns), e.columns && v(e.columns, r), s.ajax && (e.ajax = s.ajax), e.columnDefs || (e.columnDefs = []), r) {
        let a = Object.keys(r.slots);
        for (let t = 0; t < a.length; t++) {
          let l = a[t];
          if (l.match(/^column\-/)) {
            let u = l.replace("column-", "");
            e.columnDefs.push({
              target: u.match(/^\d+$/) ? parseInt(u) : u + ":name",
              render: "#" + l
            });
          }
        }
        v(e.columnDefs, r);
      }
      if (!p)
        throw new Error(
          "DataTables library not set. See https://datatables.net/tn/19 for details."
        );
      c.value = new p(A(m), e), (n = c.value) == null || n.on("preXhr", function() {
        let a = Object.keys(o);
        for (var t = 0; t < a.length; t++)
          delete o[a[t]];
      });
      for (let a of g)
        c.value && r && c.value.on(a, function() {
          var t = Array.from(arguments), l = t.shift();
          t.unshift({ event: l, dt: c }), t.unshift(a), r.emit.apply(r, t);
        });
    }), E(() => {
      var r;
      (r = c.value) == null || r.destroy(!0);
    });
    function k(r) {
      w.value = r.value ? r.value.slice() : r.slice();
    }
    function y(r) {
      return function(e, n, a, t) {
        let l = t.row + "," + t.col;
        if (!o[l]) {
          let u = S("div", r({
            cellData: e,
            colIndex: t.col,
            rowData: a,
            rowIndex: t.row,
            type: n
          }));
          o[l] = document.createElement("div"), T(u, o[l]);
        }
        return o[l];
      };
    }
    function v(r, e) {
      if (e)
        for (let a = 0; a < r.length; a++) {
          let t = r[a];
          if (typeof t.render == "string" && t.render.charAt(0) === "#") {
            var n = t.render.replace("#", "");
            e.slots[n] && (t.render = y(e.slots[n]));
          } else if (typeof t.render == "object" && typeof t.render.display == "string" && t.render.display.charAt(0) === "#") {
            var n = t.render.display.replace("#", "");
            e.slots[n] && (t.render.display = y(e.slots[n]));
          }
        }
    }
    return d({
      dt: c
    }), (r, e) => e[0] || (b(-1), e[0] = h("div", { class: "datatable" }, [
      h("table", O({
        ref_key: "table",
        ref: m
      }, r.$attrs, { style: { width: "100%" } }), [
        R(r.$slots, "default")
      ], 16)
    ]), b(1), e[0]);
  }
}), P = /* @__PURE__ */ (() => {
  const i = C;
  return i.install = (d) => {
    d.component("Datatables.netVue", i);
  }, i;
})();
export {
  C as DataTable,
  P as default
};
